import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  roles: [],
  status: "idle",
  error: null,
};

export const activeRolesByCountrySlice = createSlice({
  name: "activeRoles",
  initialState,
  reducers: {
    activeRolesRequested: (state) => {
      state.status = "loading";
    },
    activeRolesRequestFailed: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    activeRolesRequestSucceeded: (state, action) => {
      state.status = "succeeded";
      state.roles = action.payload;
    },
  },
});

export const {
  activeRolesRequested,
  activeRolesRequestFailed,
  activeRolesRequestSucceeded,
} = activeRolesByCountrySlice.actions;

export default activeRolesByCountrySlice.reducer;
